import { createEntityAdapter } from "@reduxjs/toolkit";
import { name } from "../../config/name.js";
const selectSlice = (state) => state[name];
const { selectAll, selectById, selectEntities, selectIds, selectTotal } = createEntityAdapter().getSelectors((state) => state.banks);
export {
  selectAll,
  selectById,
  selectEntities,
  selectIds,
  selectSlice,
  selectTotal
};
